import { DatepickerTypeComponent } from './types/datepicker.type';
import { RepeatTypeComponent } from './types/repeat-section.type';
import { AutocompleteTypeComponent } from './types/autocomplete.type';
import { AutocompleteUpdateTypeComponent } from './types/autocompleteUpdate.type';
import { CKEditorTypeComponent } from './types/ckeditor.type';
import { FormlyHorizontalWrapperComponent } from './wrappers/horizontal-wrapper';
import { FormlyFieldButton } from './types/button.type';
import { FormlySelectComponent } from './types/select.type';
import { FormlySelectOptionsPipe } from './pipes/select-options.pipe';
import { CTranslateService } from '../../pipes/c-translate/c-translate.service';
import { LocalStorageService } from '../../services/local-storage.service';

/**
 * Create singleton of translate service
 */
class TranslateService {
  static instance;

  static getInstance(): CTranslateService {
    if (!TranslateService.instance) {
      TranslateService.instance = new CTranslateService(new LocalStorageService());
    }
    return TranslateService.instance;
  }
}

export function minlengthValidationMessage(err, field) {
  return `Should have atleast ${field.templateOptions.minLength} characters`;
}

export function maxlengthValidationMessage(err, field) {
  return TranslateService.getInstance().translate('FORMLY_MAX_LENGTH_VALIDATION_MESSAGE') + `${field.templateOptions.maxLength} ` +
  TranslateService.getInstance().translate('FORMLY_CHARACTERS');
}

export function minValidationMessage(err, field) {
  return `This value should be more than ${field.templateOptions.min}`;
}

export function maxValidationMessage(err, field) {
  return `This value should be less than ${field.templateOptions.max}`;
}

export function requireMessage(err, field) {
  return TranslateService.getInstance().translate('FORMLY_REQUIRE_MESSAGE');
}

export const formlyConfig = {
  wrappers: [{ name: 'form-field-horizontal', component: FormlyHorizontalWrapperComponent }],
  types: [
    {name: 'datepicker', component: DatepickerTypeComponent, extends: 'input'},
    {name: 'ckeditor', component: CKEditorTypeComponent, extends: 'textarea'},
    {name: 'autocomplete', component: AutocompleteTypeComponent, extends: 'input'},
    {name: 'autocompleteUpdate', component: AutocompleteUpdateTypeComponent, extends: 'input'},
    {name: 'repeat', component: RepeatTypeComponent},
    {name: 'button', component: FormlyFieldButton},
    {name: 'select', component: FormlySelectComponent}
  ],
  validationMessages: [
    {name: 'required', message: requireMessage},
    {name: 'minlength', message: minlengthValidationMessage},
    {name: 'maxlength', message: maxlengthValidationMessage},
    {name: 'min', message: minValidationMessage},
    {name: 'max', message: maxValidationMessage}
  ],
};

export const formlyDeclarations = [
  FormlySelectOptionsPipe,
  DatepickerTypeComponent,
  AutocompleteTypeComponent,
  AutocompleteUpdateTypeComponent,
  RepeatTypeComponent,
  CKEditorTypeComponent,
  FormlyHorizontalWrapperComponent,
  FormlyFieldButton,
  FormlySelectComponent
];
